const durationFormatter = new Intl.DurationFormat(undefined, { style: 'short' })

export const formatDuration = (seconds: number | null): string => {
  const totalSeconds = Math.floor(seconds ?? 0)
  return durationFormatter.format({
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  })
}
